import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 310,
	height: 40,
	viewBox: "0 0 310 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M67.2518 0.802734H23.0537C23.0435 13.0244 32.9289 22.9213 45.1342 22.932C57.339 22.9423 67.2416 13.0244 67.2518 0.802734Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.007 0.802734H0.760742V39.1999H20.007V0.802734Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.5226 0.802734H70.2764V39.208H89.5226V0.802734Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.5687 39.2044C57.5691 39.1612 57.5721 39.1235 57.5721 39.0798C57.5781 32.2023 52.0149 26.6222 45.1466 26.6162C38.2784 26.6102 32.7058 32.1809 32.7002 39.0584C32.7002 39.1055 32.7032 39.1573 32.7036 39.204L57.5687 39.2044Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.186 4.17278C124.965 7.93037 122.186 18.1129 122.147 21.6696H121.814C121.781 18.1125 118.909 7.8443 117.657 4.1655L116.515 0.803162H108.048V26.6031H114.019L114.037 5.49554H114.369C114.551 9.29508 116.463 18.148 117.642 21.9077L119.078 26.6031H124.875L126.319 21.915C127.43 18.2379 129.284 9.3075 129.472 5.50839H129.804L129.786 26.6027H135.779V0.802734H127.297L126.187 4.17193L126.186 4.17278Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.172 7.9043H158.374V26.6027H164.172V7.9043Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173.033 0.802734H167.236V26.6031H173.033V0.802734Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.474 0.802734H175.677V26.6031H181.474V0.802734Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.025 7.69922V20.3996C212.334 22.5501 209.338 22.5711 209.34 19.1086V7.69965H203.579V19.392C203.579 23.0691 204.616 25.5284 206.481 26.3749C208.659 27.3954 212.407 26.2777 215.017 24.3688L215.18 26.4302H220.82V7.70007H215.026L215.025 7.69922Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.824 7.69922V20.3996C277.132 22.5501 274.137 22.5711 274.139 19.1086V7.69965H268.378V19.392C268.378 23.0691 269.414 25.5284 271.28 26.3749C273.457 27.3954 277.205 26.2777 279.816 24.3688L279.979 26.4302H285.619V7.70007H279.825L279.824 7.69922Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.192 7.69965C231.916 7.9904 229.788 9.28404 228.981 10.6363V7.69965H223.172V26.4302H228.981V17.6728C228.982 15.1887 230.117 13.6424 232.333 13.6441H235.192V7.69922L235.192 7.69965Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.618 16.9846L308.349 7.69922H301.222L299.04 12.3227C298.67 13.0986 298.151 15.3908 298.15 16.2417H298.003C298.004 15.3912 297.452 13.0977 297.12 12.3209L294.945 7.69922H287.819L293.571 16.9769L286.843 26.4302H294.007L297.002 21.2325C297.446 20.4562 298.002 18.2748 298.002 17.4244H298.15C298.149 18.2748 298.701 20.457 299.107 21.2342L302.13 26.4302H309.256L302.618 16.9846Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M257.764 7.27051C253.416 7.27051 250.161 9.11183 249.307 12.7191L254.65 13.4154C254.966 12.3089 255.952 11.4687 257.712 11.4696C259.21 11.47 260.282 12.0759 260.281 13.5875C260.28 14.9878 258.108 15.0687 255.799 15.2619C251.705 15.5971 248.763 17.1229 248.763 21.1849C248.763 25.5831 252.173 26.8018 254.86 26.8018C256.62 26.8018 259.196 26.228 260.462 23.7812L260.625 26.4305H266.164V13.5901C266.164 9.50536 262.436 7.27094 257.763 7.27094L257.764 7.27051ZM256.776 22.7984C255.362 22.7984 254.342 22.0713 254.342 20.8505C254.342 19.6836 255.188 19.1971 255.594 19.0057C256.338 18.6542 257.127 18.5617 260.329 18.1189L260.328 19.6348C260.328 21.5733 258.682 22.7993 256.776 22.7993V22.7984Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M247.945 12.5728V7.69972H242.517V3.05273H236.703V20.7607C236.701 23.8785 239.208 26.4127 242.322 26.4303C243.237 26.4354 243.768 26.4294 246.988 26.4307V20.9491H242.517V12.5732H247.945L247.945 12.5728Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.267 6.77163C163.071 6.77163 164.534 5.30691 164.534 3.50007C164.534 1.69324 163.071 0.228516 161.267 0.228516C159.463 0.228516 158 1.69324 158 3.50007C158 5.30691 159.463 6.77163 161.267 6.77163Z",
			fill: "#C0543A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.93 20.1163C195.334 21.4326 193.934 22.3203 192.44 22.3203C190.426 22.3182 188.803 21.0618 188.329 18.719L201.539 18.7246L201.581 18.2792H201.578C202.678 4.3233 183.184 4.00129 183.173 17.0987C183.167 23.3848 186.971 26.7532 192.436 26.7575H192.438H192.44C196.356 26.7575 199.133 24.8403 200.495 22.2711L195.929 20.1159L195.93 20.1163ZM196.458 15.1096L188.344 15.1062C189.278 10.6669 195.529 10.6694 196.458 15.1096Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M150.675 20.1163C150.079 21.4326 148.68 22.3203 147.185 22.3203C145.172 22.3182 143.549 21.0618 143.074 18.719L156.284 18.7246L156.325 18.2792H156.323C157.423 4.3233 137.929 4.00128 137.918 17.0987C137.912 23.3848 141.716 26.7532 147.181 26.7575H147.183C147.183 26.7575 147.184 26.7575 147.185 26.7575C151.101 26.7575 153.878 24.8403 155.24 22.2711L150.675 20.1159L150.675 20.1163ZM151.203 15.1096L143.089 15.1062C144.023 10.6669 150.274 10.6694 151.203 15.1096Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.527 36.7443C181.37 36.7443 181.238 36.6912 181.134 36.5845C181.029 36.4779 180.977 36.3473 180.977 36.1927C180.977 36.0381 181.029 35.9084 181.134 35.8018C181.239 35.6951 181.37 35.6416 181.528 35.6416C181.687 35.6416 181.821 35.6947 181.927 35.7996C182.034 35.905 182.087 36.036 182.087 36.1936C182.087 36.3512 182.034 36.4826 181.927 36.5871C181.821 36.6924 181.687 36.7447 181.528 36.7447L181.527 36.7443Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.953 36.7296C262.796 36.7296 262.664 36.6765 262.56 36.5699C262.455 36.4633 262.402 36.3327 262.402 36.1781C262.402 36.0235 262.455 35.8937 262.56 35.7871C262.665 35.6805 262.796 35.627 262.954 35.627C263.113 35.627 263.246 35.6801 263.353 35.785C263.459 35.8903 263.512 36.0213 263.512 36.1789C263.512 36.3365 263.459 36.468 263.353 36.5725C263.246 36.6778 263.113 36.73 262.954 36.73L262.953 36.7296Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.194 33.2089L108.048 33.208V39.203H108.943V36.7964H110.192C111.88 36.7964 112.384 35.8342 112.384 35.0078C112.384 34.061 111.78 33.208 110.194 33.208L110.194 33.2089ZM110.157 36.0865H108.945L108.946 33.9193H110.158C111.222 33.9193 111.469 34.4241 111.469 35.0078C111.469 35.4668 111.292 36.0865 110.157 36.0865Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.093 33.2084L115.195 33.208L115.192 39.203H118.964L118.964 38.5269L116.09 38.5264L116.093 33.2084Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.763 33.208L121.452 39.203H122.395L122.947 37.727H125.538L126.086 39.203H127.047L124.741 33.208H123.763ZM123.203 37.0422L124.247 34.2421L125.284 37.0427H123.203V37.0422Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M190.779 33.208L188.469 39.203H189.412L189.964 37.727H192.554L193.102 39.203H194.063L191.758 33.208H190.779ZM190.219 37.0422L191.264 34.2421L192.3 37.0427H190.219V37.0422Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.011 33.208L225.7 39.203H226.643L227.196 37.727H229.786L230.334 39.203H231.295L228.989 33.208H228.011ZM227.451 37.0422L228.495 34.2421L229.532 37.0427H227.451V37.0422Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.186 33.8775C132.659 33.8775 133.568 33.9755 133.865 35.0426H134.852C134.534 33.5828 133.393 33.1152 132.186 33.1152C130.198 33.1152 129.194 34.5301 129.194 36.2142C129.194 38.041 130.319 39.3158 132.183 39.3158C133.176 39.3158 134.509 38.9779 134.851 37.4239H133.863C133.578 38.4594 132.657 38.5536 132.184 38.5536C130.836 38.5536 130.11 37.6081 130.11 36.2146C130.11 34.8071 130.862 33.8775 132.186 33.8775Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.95 33.8775C245.422 33.8775 246.332 33.9755 246.628 35.0426H247.616C247.298 33.5828 246.156 33.1152 244.95 33.1152C242.962 33.1152 241.958 34.5301 241.958 36.2142C241.958 38.041 243.082 39.3158 244.947 39.3158C245.939 39.3158 247.272 38.9779 247.615 37.4239H246.627C246.342 38.4594 245.42 38.5536 244.947 38.5536C243.6 38.5536 242.874 37.6081 242.874 36.2146C242.874 34.8071 243.625 33.8775 244.95 33.8775Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M272.665 33.8775C273.138 33.8775 274.048 33.9755 274.344 35.0426H275.332C275.014 33.5828 273.872 33.1152 272.666 33.1152C270.677 33.1152 269.674 34.5301 269.674 36.2142C269.674 38.041 270.798 39.3158 272.663 39.3158C273.655 39.3158 274.988 38.9779 275.331 37.4239H274.343C274.058 38.4594 273.136 38.5536 272.663 38.5536C271.316 38.5536 270.59 37.6081 270.59 36.2146C270.59 34.8071 271.341 33.8775 272.665 33.8775Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.769 39.203H141.74V38.5144L138.667 38.5132L138.668 36.5262L141.47 36.5267V35.8407L138.668 35.8411L138.669 33.9227H141.74L141.74 33.208H137.771L137.769 39.203Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M154.355 39.203H158.327V38.5144L155.254 38.5132L155.255 36.5262L158.056 36.5267L158.057 35.8407L155.255 35.8411L155.256 33.9227H158.327L158.327 33.208H154.358L154.355 39.203Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.537 39.203H254.509V38.5144L251.435 38.5132L251.436 36.5262L254.238 36.5267L254.238 35.8407L251.436 35.8411L251.437 33.9227H254.508V33.208H250.539L250.537 39.203Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M285.853 39.203H289.824V38.5144L286.751 38.5132L286.752 36.5262L289.553 36.5267V35.8407L286.752 35.8411L286.753 33.9227H289.824L289.824 33.208H285.855L285.853 39.203Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M147.927 37.2752L145.8 33.208H144.74L144.738 39.203H145.636L145.638 34.7307L147.576 38.38H148.267L150.218 34.7239L150.216 39.203H151.114L151.116 33.208H150.047L147.927 37.2752Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.417 37.831L162.213 33.208H161.315L161.312 39.203H162.21L162.212 34.6348L165.416 39.203H166.314L166.317 33.208H165.418L165.417 37.831Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M238.141 37.831L234.937 33.208H234.039L234.036 39.203H234.934L234.936 34.6348L238.14 39.203H239.038L239.04 33.208H238.142L238.141 37.831Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M169.07 33.9227H170.929L170.927 39.203H171.825L171.827 33.9227H173.695V33.208H169.07V33.9227Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M304.627 33.9227H306.486L306.483 39.203H307.381L307.384 33.9227H309.252V33.208H304.627V33.9227Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.489 35.8529C206.239 35.7694 206.008 35.6996 205.802 35.634C205.008 35.3818 204.783 35.1343 204.783 34.6873C204.783 34.2068 205.113 33.8227 205.843 33.8227C206.564 33.8227 206.954 34.2749 206.965 34.7823H207.917C207.931 33.9165 207.22 33.0947 205.87 33.0947C204.624 33.0947 203.84 33.7687 203.84 34.7639C203.84 35.5861 204.366 36.0241 205.312 36.323C205.558 36.4005 205.792 36.4785 206.017 36.5461C207.013 36.8467 207.17 37.2394 207.17 37.6428C207.17 38.2209 206.678 38.5759 205.957 38.5759C205.115 38.5759 204.621 38.0984 204.593 37.3931H203.65C203.655 38.5904 204.627 39.2953 205.957 39.2953C207.539 39.2953 208.104 38.3172 208.104 37.5914C208.104 36.4823 207.303 36.1239 206.489 35.8524V35.8529Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M199.381 35.8529C199.131 35.7694 198.901 35.6996 198.695 35.634C197.9 35.3818 197.676 35.1343 197.676 34.6873C197.676 34.2068 198.005 33.8227 198.736 33.8227C199.457 33.8227 199.846 34.2749 199.858 34.7823H200.81C200.823 33.9165 200.113 33.0947 198.763 33.0947C197.517 33.0947 196.733 33.7687 196.733 34.7639C196.733 35.5861 197.258 36.0241 198.205 36.323C198.451 36.4005 198.685 36.4785 198.909 36.5461C199.906 36.8467 200.063 37.2394 200.063 37.6428C200.063 38.2209 199.57 38.5759 198.85 38.5759C198.008 38.5759 197.514 38.0984 197.486 37.3931H196.543C196.548 38.5904 197.519 39.2953 198.85 39.2953C200.432 39.2953 200.997 38.3172 200.997 37.5914C200.997 36.4823 200.196 36.1239 199.381 35.8524V35.8529Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.843 36.9632C214.843 38.0984 214.209 38.53 213.353 38.53C212.843 38.53 211.853 38.3591 211.853 36.9619L211.855 33.2021H210.957L210.955 36.9529C210.955 39.0884 212.722 39.3008 213.334 39.3008C214.058 39.3008 215.741 39.0203 215.741 36.955L215.743 33.2039H214.845L214.843 36.9632Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.109 34.989C223.109 33.9428 222.394 33.208 220.955 33.208H218.827L218.824 39.203H219.722V36.7686L220.892 36.7682L222.129 39.203H223.171L221.823 36.6538C222.561 36.4513 223.109 35.8582 223.109 34.989ZM219.723 33.9253H220.892C221.814 33.9253 222.184 34.3466 222.184 35.0052C222.184 35.4913 221.938 36.1169 220.891 36.1169H219.723V33.9248V33.9253Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M282.676 34.989C282.676 33.9428 281.961 33.208 280.521 33.208H278.393L278.391 39.203H279.289V36.7686L280.458 36.7682L281.695 39.203H282.737L281.39 36.6538C282.127 36.4513 282.676 35.8582 282.676 34.989ZM279.289 33.9253H280.459C281.38 33.9253 281.751 34.3466 281.751 35.0052C281.751 35.4913 281.504 36.1169 280.458 36.1169H279.289V33.9248V33.9253Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M288.83 31.8822L288.713 31.1885L286.854 32.2667L286.943 32.8662L288.83 31.8822Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M294.967 33.208H293.037L293.034 39.203H294.965C297.192 39.203 298.19 38.0811 298.19 36.2449C298.19 34.2473 297.016 33.208 294.967 33.208ZM294.929 38.5127H293.933L293.934 33.9561H294.931C296.382 33.9561 297.265 34.5243 297.265 36.244C297.265 37.7989 296.528 38.5127 294.929 38.5127Z",
			fill: "#302E2D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M302.007 33.208H301.109V39.203H302.007V33.208Z",
			fill: "#302E2D"
		})
	]
});
export default SvgBrandLogo;
